import {
  AccountType,
  GetV1CompaniesAccountsTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { uniqBy } from 'lodash-es';

import { AccountTypeahead } from '~hooks/useAccount/models';
import { LabeledOption } from '~types/LabeledOption';

export type ActingCompany = { id: string; name: string };

export const CONNECTED_VENDOR_ACCOUNTS_QUERY = {
  'filter[account_types]': [AccountType.VENDOR],
  'filter[connected]': true,
} satisfies NonNullable<GetV1CompaniesAccountsTypeaheadData['query']>;

/**
 * Values a vendor by its connected company rather than its account, because drivers and trucks
 * belong to companies; an account with no connected company has neither on Tread.
 */
export function connectedVendorCompanyOption(
  account: AccountTypeahead,
): LabeledOption | null {
  return account.connectedCompanyId
    ? { label: account.name, value: account.connectedCompanyId }
    : null;
}

/** Your own company isn't a search result, so it leads only while it matches the search. */
export function withOwnCompanyFirst<Option extends LabeledOption>(
  vendorOptions: Option[],
  ownCompanyOption: Option | undefined,
  searchQuery: string,
): Option[] {
  const ownCompanyMatchesSearch = ownCompanyOption?.label
    .toLowerCase()
    .includes(searchQuery.trim().toLowerCase());
  const options =
    ownCompanyOption && ownCompanyMatchesSearch
      ? [ownCompanyOption, ...vendorOptions]
      : vendorOptions;

  // Two accounts can connect to the same company.
  return uniqBy(options, (option) => option.value);
}
